import React from 'react'
import * as RT from '../../constants/Routing'
import { Link } from 'react-router-dom'
import defaultPhoto from '../../lib/images/user-thumb-default.png'

export default class Component extends React.Component {
  render = () => {
    const currentUser = this.props.user
    const currentPath = this.props.currentPath
    
    const menuHide = !!this.props.menuHide
    const cardEditHide = !!this.props.cardEditHide
    const bankEditHide = !!this.props.bankEditHide

    const photo = (!!currentUser && currentUser.photo) ? currentUser.photo : defaultPhoto

    const thumbStyle = {
      backgroundImage: `url(${photo})`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      width: '80px',
      height: '80px',
      margin: '0 auto 0',
      borderRadius: '50%'
    }

    if (currentUser) {
      return (
        <div className='mypage-card'>
          <div className={'user-mypage-header row pt15 ' + (menuHide ? 'with-border-b mb10' : 'pb5')}>
            <div className='col-4'>
              <div className='user-thumb-form shadow-sm' style={thumbStyle}></div>
              <Link to={RT.COMMUNITY_NEW_PATH} className='btn btn-submit btn-to-circle-create'>
                <i className="material-icons">add</i>
                サークル作成
              </Link>
            </div>
            <div className='col-8'>
              <div className='user-profile-box'>
                <p className='user-name'>{currentUser.name}</p>
                <p>{currentUser.birthday}</p>
                <p>{currentUser.email}</p>
                <p>
                  <i className={"material-icons card-icon " + (currentUser.has_card ? 'has-card' : '')}>credit_card</i>
                  {(() => {
                    if (!cardEditHide) {
                      if (currentUser.has_card) {
                        return (
                          <Link to={RT.USER_CREDIT_EDIT_PATH} className=''>登録クレジットカード情報</Link>
                        )
                      } else {
                        return (
                          <Link to={RT.USER_CREDIT_EDIT_PATH} className=''>クレジットカード情報を登録</Link>
                        )
                      }
                    }
                  })()}
                </p>
                <p>
                  <i className={"material-icons account-icon " + (currentUser.has_account && currentUser.verified ? 'has-account' : '')}>account_balance</i>
                  {(() => {
                    if (!bankEditHide) {
                      if (currentUser.has_account) {
                        return (
                          <Link to={RT.USER_BANK_EDIT_PATH} className=''>登録銀行口座情報</Link>
                        )
                      } else {
                        return (
                          <Link to={RT.USER_BANK_EDIT_PATH}>銀行口座情報を登録</Link>
                        )
                      }
                    }
                  })()}
                </p>
              </div>
            </div>
            {(() => {
              if (currentPath !== RT.USER_EDIT_PATH) {
                return(
                  <Link to={RT.USER_EDIT_PATH} className='btn btn-circle'>
                    <i className="material-icons edit-link">create</i>
                  </Link>
                )
              }
            })()}
          </div>

          {(() => {
            if (!menuHide) {
              return (
                <ul className='float-menu mb30 row'>
                  <li className='col-4'><Link to={RT.USER_MYPAGE_PATH} className={currentPath === RT.USER_MYPAGE_PATH ? 'active' : ''}>myサークル</Link></li>
                  <li className='col-4'><Link to={RT.USER_JOINED_COMMUNITIES_PATH} className={currentPath === RT.USER_JOINED_COMMUNITIES_PATH ? 'active' : ''}>参加中サークル</Link></li>
                  <li className='col-4'><Link to={RT.USER_MESSAGES_PATH} className={(currentPath === RT.USER_MESSAGES_PATH || (currentPath && currentPath.match(/message/))) ? 'active' : ''}>メッセージ</Link></li>
                </ul>
              )
            }
          })()}

        </div>
      )
    } else {
      return (
        <div></div>
      )
    }

  }

}


// WEBPACK FOOTER //
// ./src/components/User/ProfileCard.js